function passwordMatch(value, key, params, formValues) {
    if (formValues[params.passwordFieldName] !== formValues["retype_password"]) {
        return { key: key };
    }
    return {};
}

function counter(condition, input) {
    return input.filter(condition).length;
}

function isUpperCase(element) {
    return element.toUpperCase() === element;
}

function isLowerCase(element) {
    return !isUpperCase(element);
}

function isSpecial(element) {
    return "~!@#$%^&*()_+-.=?<>,:;{}|".indexOf(element) !== -1;
}
function isNumber(element) {
    return "0123456789".indexOf(element) !== -1;
}

function requiredCharacter(value, key, params) {
    if (params.enableEmptyAnyway && value === "") return {};

    var keyFunctionMapping = {
        insufficient_lowercase_chars: isLowerCase, // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
        insufficient_uppercase_chars: isUpperCase, // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
        insufficient_special_chars: isSpecial, // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
        insufficient_number_chars: isNumber, // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
    };
    if (!keyFunctionMapping.hasOwnProperty(key)) {
        throw new Error("Unknown key: ", key);
    }
    var charArray = value.split("");
    if (params.min !== null && params.min > 0) {
        if (counter(keyFunctionMapping[key], charArray) < params.min) return { key: key, min: params.min };
    }
    return {};
}

// This 'validator' checks if the value is -1. If it is, it returns its key to show invalid format error
function refreshTokenDurationFormat(value, key) {
    if (value === -1) {
        return { key: key };
    }

    return {};
}

// Checks if an interval is within a range. If not, params.min_text_value and params.max_text_value are returned
// along with the error key to show min and max in a custom format
function intervalRange(value, key, params) {
    if (value < params.min || value > params.max) {
        return { key: key, min: params.min_text_value, max: params.max_text_value };
    }

    return {};
}

function requiredIfFieldEqualsTo(value, key, params, formValues) {
    var fieldName = params.field;
    var fieldValue = params.value;

    var formValue = formValues[fieldName];

    if (formValue === fieldValue && (value === null || value === undefined || value.length === 0)) {
        return { key: key };
    }

    return {};
}

module.exports = {
    passwordMatch: passwordMatch,
    requiredCharacter: requiredCharacter,
    intervalRange: intervalRange,
    refreshTokenDurationFormat: refreshTokenDurationFormat,
    requiredIfFieldEqualsTo: requiredIfFieldEqualsTo,
};
